(() => {
  if (window.PduCheckoutGuard) return;
  const config = document.getElementById('pdu-checkout-guard-config');
  const rootUrl = config ? JSON.parse(config.textContent).rootUrl : '/';
  const root = new URL(rootUrl, location.origin);
  const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const isReservedCart = (cart) => {
    if (!cart || !Array.isArray(cart.items) || cart.items.length !== 1) return false;
    const item = cart.items[0], properties = item.properties || {};
    return item.quantity === 1 && uuid.test(properties['_Price Drop Reservation'] || '') && uuid.test(properties['_Price Drop Session'] || '');
  };
  let navigating = false;
  const stop = (event) => { event.preventDefault(); event.stopImmediatePropagation(); };
  const openDrop = () => { location.assign(root.href); };
  const openReservedCheckout = async () => {
    if (navigating) return;
    navigating = true;
    try {
      const response = await fetch(new URL('cart.js', root), { credentials:'same-origin', cache:'no-store', headers:{ Accept:'application/json' } });
      if (!response.ok || !isReservedCart(await response.json())) { openDrop(); return; }
      location.assign(new URL('checkout', root).href);
    } catch (_) { openDrop(); }
    finally { navigating = false; }
  };
  const isCartAdd = (form) => {
    if (!form || !form.action) return false;
    const url = new URL(form.action, location.origin);
    return url.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
  };
  document.addEventListener('submit', (event) => {
    if (isCartAdd(event.target)) { stop(event); openDrop(); return; }
    if (event.submitter?.name === 'checkout') { stop(event); void openReservedCheckout(); }
  }, true);
  document.addEventListener('click', (event) => {
    const path = event.composedPath();
    const element = path.find(node => node instanceof Element && node.matches('button,input,a'));
    if (!element) return;
    if (element.name === 'add' || isCartAdd(element.form) || element.closest('quick-add-component,add-to-cart-component,sticky-add-to-cart')) { stop(event); openDrop(); return; }
    if (element.name === 'checkout') { stop(event); void openReservedCheckout(); return; }
    if (element instanceof HTMLAnchorElement) {
      const url = new URL(element.href, location.origin);
      if (url.origin === location.origin && /\/(?:checkout|checkouts)(?:\/|$)/.test(url.pathname)) { stop(event); void openReservedCheckout(); }
    }
  }, true);
  window.PduCheckoutGuard = Object.freeze({ isReservedCart });
})();
